import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';

import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import '../../../assets/auctions/auctions.scss';
import {
  FlashMessage,
  Heading,
  IconAuction,
  IconSmile,
  ImageCdn,
  InputTileOption,
  InputTiles,
  SheetLayoutContent,
  SheetLayoutContentWrapper,
  SheetLayoutHeader,
} from '../../../brenger-shared-ui';
import { useTypedSelector } from '../../../hooks';
import { RootState } from '../../../types';
import { getActiveLanguageSettings, translate } from '../../../utils/localization';
import FooterLayout from '../containers/FooterLayout';
import { actions } from '../ducks';
import { proceed } from '../proceed';

export type AuctionType =
  | 'belgaveilingen'
  | 'troostwijk'
  | 'onlineveilingmeester'
  | 'vavato'
  | 'Lot-Tissimo'
  | 'Justiz Auktion'
  | 'bonanza'
  | 'ebid'
  | 'others';

export const SubStepAuctionTypes: React.FC<RouteComponentProps> = ({ location }) => {
  const error = useTypedSelector((state: RootState) => state.generalTransport.error);
  const auctionType = useTypedSelector(state => state.generalTransport.choices?.auction_type);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(actions.setProgress(2));
    dispatch(actions.resetChoice(['auction_type']));
  }, [location.pathname]);

  // Setup options
  const otherOption: InputTileOption<AuctionType> = {
    value: 'others',
    title: String(translate('request_flow.situation.other')),
    suffix: <IconSmile />,
    prefix: <IconAuction />,
  };
  const options: InputTileOption<AuctionType>[] = {
    de: [
      {
        value: 'Lot-Tissimo',
        title: 'Lot-Tissimo',
        suffix: <IconSmile />,
        prefix: <ImageCdn src={'partners/lot-tissimo.jpg'} height={30} width={30} alt={'Lot Tissimo'} />,
      },
      {
        value: 'Justiz Auktion',
        title: 'Justiz Auktion',
        suffix: <IconSmile />,
        prefix: <ImageCdn src={'partners/Justiz-Auktion.png'} height={30} width={30} alt={'Justiz Auktion'} />,
      },
      otherOption,
    ],
  }[getActiveLanguageSettings().labels.short] || [
    {
      value: 'troostwijk',
      title: 'Troostwijk',
      suffix: <IconSmile />,
      prefix: <ImageCdn src={'partners/troostwijk-logo.svg'} height={30} width={30} alt={'Troostwijk'} />,
    },
    {
      value: 'onlineveilingmeester',
      title: 'Online Veilingmeester',
      suffix: <IconSmile />,
      prefix: <ImageCdn src={'partners/onlineveiling.png'} height={30} width={30} alt={'Online Veilingmeester'} />,
    },
    {
      value: 'catawiki',
      title: 'Catawiki',
      suffix: <IconSmile />,
      prefix: <ImageCdn src={'partners/catawiki.png'} height={30} width={30} alt={'Catawiki'} />,
    },
    {
      value: 'belgaveilingen',
      title: 'Belga',
      suffix: <IconSmile />,
      prefix: <ImageCdn src={'partners/belga.jpg'} height={30} width={30} alt={'Belga'} />,
    },
    otherOption,
  ];

  return (
    <SheetLayoutContentWrapper>
      <SheetLayoutHeader>
        <Heading size={2}>
          <Translate id={'request_flow.auction.select_auction'} />
        </Heading>
      </SheetLayoutHeader>
      <SheetLayoutContent>
        <div className={'auction-types question-wrapper'}>
          <InputTiles
            value={auctionType}
            id={'auctionType'}
            name={'auctionType'}
            options={options}
            onChange={newAuctionType => {
              dispatch(actions.setChoice({ auction_type: newAuctionType as AuctionType }));
              proceed();
            }}
          />
        </div>
        {!!error && <FlashMessage type={'error'} message={error} />}
      </SheetLayoutContent>
      <FooterLayout customSubmitFunction={proceed} />
    </SheetLayoutContentWrapper>
  );
};
